// extracted by mini-css-extract-plugin
export default {"wrap":"style_wrap__JMtGv","positionLeft":"style_positionLeft__13dds","positionRight":"style_positionRight__o60SD"};